import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Textarea,
    Input,
    Text,
    VStack,
    HStack,
    Box,
    Link,
} from '@chakra-ui/react';

const EditEvent = ({ isOpen, onClose, eventData, onSave }) => {
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [attendees, setAttendees] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (eventData) {
            setSubject(eventData.subject || '');
            setDescription(eventData.description || '');
            setAttendees(eventData.attendees || []);
        }
    }, [eventData]);

    const handleSave = async () => {
        setSaving(true);
        try {
            await onSave({
                ...eventData,
                subject,
                description,
                attendees,
            });
            onClose();
        } catch (error) {
            console.error('Error saving event:', error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit Event</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4}>
                        <Input
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="Event subject"
                        />
                        <Textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Event description"
                            rows={6}
                        />
                        <Text fontSize="sm" color="gray.500">
                            Edit the subject and description of the event.
                        </Text>
                        <Box w="full">
                            <Text fontWeight="bold" mb={2}>Attendees</Text>
                            <VStack spacing={2} align="stretch">
                                {attendees.map((attendee, index) => (
                                    <HStack key={index} spacing={2}>
                                        {attendee.name !== attendee.email ?(
                                            <Text>{attendee.name} ({attendee.email})</Text>
                                        ) : (
                                            <Text>{attendee.email}</Text>
                                        )}
                                    </HStack>
                                ))}
                            </VStack>
                        </Box>
                        {eventData?.metadata?.htmlLink && (
                            <Link href={eventData.metadata.htmlLink} isExternal color="blue.500">
                                View in Google Calendar
                            </Link>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="blue"
                        onClick={handleSave}
                        isLoading={saving}
                    >
                        Save Changes
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditEvent;